const { default: Category } = require("models/Category");

export const CATEGORIES = [
  new Category (1, 'Health, Safety, and Environment'),
  new Category (2, 'Behavior-Based Safety'),
  new Category (3, 'Human & Organizational Performance'),
];

